import { Html, Link, Row } from '@react-email/components'
import * as React from 'react'

export interface JobAssignmentChangedEmailProps {
  url: string
  currentUser: string
  siteName: string
  startDate: string
  endDate: string
  role: string
  shift: string
}

export const JobAssignmentChangedEmail = (
  props: JobAssignmentChangedEmailProps
) => {
  const { url, siteName, currentUser, role, startDate, endDate, shift } = props

  return (
    <Html lang='en'>
      <Row>
        {currentUser} has changed your assignment on a job at {siteName}:
      </Row>
      <Row>Role: {role}</Row>
      <Row>Start Date: {startDate}</Row>
      <Row>End Date: {endDate}</Row>
      <Row>Shift: {shift}</Row>
      <Row>
        <Link href={url}>Handoff Page</Link>
      </Row>
      <Row>If needed, reach out to {currentUser} for additional info. </Row>
    </Html>
  )
}
